// source: src/common/insight/entity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_insight_string_metadata_pb = require('../../../src/common/insight/string_metadata_pb.js');
goog.object.extend(proto, src_common_insight_string_metadata_pb);
var src_common_insight_numeric_metadata_pb = require('../../../src/common/insight/numeric_metadata_pb.js');
goog.object.extend(proto, src_common_insight_numeric_metadata_pb);
var src_common_insight_date_metadata_pb = require('../../../src/common/insight/date_metadata_pb.js');
goog.object.extend(proto, src_common_insight_date_metadata_pb);
var src_common_insight_bool_metadata_pb = require('../../../src/common/insight/bool_metadata_pb.js');
goog.object.extend(proto, src_common_insight_bool_metadata_pb);
goog.exportSymbol('proto.loupe.common.insight.Entity', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.insight.Entity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.insight.Entity.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.insight.Entity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.insight.Entity.displayName = 'proto.loupe.common.insight.Entity';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.insight.Entity.repeatedFields_ = [4,5,6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.insight.Entity.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.insight.Entity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.insight.Entity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.insight.Entity.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, ""),
    relation: jspb.Message.getFieldWithDefault(msg, 3, ""),
    stringMetadataList: jspb.Message.toObjectList(msg.getStringMetadataList(),
    src_common_insight_string_metadata_pb.StringMetadata.toObject, includeInstance),
    numericMetadataList: jspb.Message.toObjectList(msg.getNumericMetadataList(),
    src_common_insight_numeric_metadata_pb.NumericMetadata.toObject, includeInstance),
    dateMetadataList: jspb.Message.toObjectList(msg.getDateMetadataList(),
    src_common_insight_date_metadata_pb.DateMetadata.toObject, includeInstance),
    boolMetadataList: jspb.Message.toObjectList(msg.getBoolMetadataList(),
    src_common_insight_bool_metadata_pb.BoolMetadata.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.insight.Entity}
 */
proto.loupe.common.insight.Entity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.insight.Entity;
  return proto.loupe.common.insight.Entity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.insight.Entity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.insight.Entity}
 */
proto.loupe.common.insight.Entity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelation(value);
      break;
    case 4:
      var value = new src_common_insight_string_metadata_pb.StringMetadata;
      reader.readMessage(value,src_common_insight_string_metadata_pb.StringMetadata.deserializeBinaryFromReader);
      msg.addStringMetadata(value);
      break;
    case 5:
      var value = new src_common_insight_numeric_metadata_pb.NumericMetadata;
      reader.readMessage(value,src_common_insight_numeric_metadata_pb.NumericMetadata.deserializeBinaryFromReader);
      msg.addNumericMetadata(value);
      break;
    case 6:
      var value = new src_common_insight_date_metadata_pb.DateMetadata;
      reader.readMessage(value,src_common_insight_date_metadata_pb.DateMetadata.deserializeBinaryFromReader);
      msg.addDateMetadata(value);
      break;
    case 7:
      var value = new src_common_insight_bool_metadata_pb.BoolMetadata;
      reader.readMessage(value,src_common_insight_bool_metadata_pb.BoolMetadata.deserializeBinaryFromReader);
      msg.addBoolMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.insight.Entity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.insight.Entity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.insight.Entity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.insight.Entity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRelation();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStringMetadataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      src_common_insight_string_metadata_pb.StringMetadata.serializeBinaryToWriter
    );
  }
  f = message.getNumericMetadataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      src_common_insight_numeric_metadata_pb.NumericMetadata.serializeBinaryToWriter
    );
  }
  f = message.getDateMetadataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      src_common_insight_date_metadata_pb.DateMetadata.serializeBinaryToWriter
    );
  }
  f = message.getBoolMetadataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      src_common_insight_bool_metadata_pb.BoolMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loupe.common.insight.Entity.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.insight.Entity} returns this
 */
proto.loupe.common.insight.Entity.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.loupe.common.insight.Entity.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.insight.Entity} returns this
 */
proto.loupe.common.insight.Entity.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string relation = 3;
 * @return {string}
 */
proto.loupe.common.insight.Entity.prototype.getRelation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.insight.Entity} returns this
 */
proto.loupe.common.insight.Entity.prototype.setRelation = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated StringMetadata string_metadata = 4;
 * @return {!Array<!proto.loupe.common.insight.StringMetadata>}
 */
proto.loupe.common.insight.Entity.prototype.getStringMetadataList = function() {
  return /** @type{!Array<!proto.loupe.common.insight.StringMetadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_insight_string_metadata_pb.StringMetadata, 4));
};


/**
 * @param {!Array<!proto.loupe.common.insight.StringMetadata>} value
 * @return {!proto.loupe.common.insight.Entity} returns this
*/
proto.loupe.common.insight.Entity.prototype.setStringMetadataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.loupe.common.insight.StringMetadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.insight.StringMetadata}
 */
proto.loupe.common.insight.Entity.prototype.addStringMetadata = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.loupe.common.insight.StringMetadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.insight.Entity} returns this
 */
proto.loupe.common.insight.Entity.prototype.clearStringMetadataList = function() {
  return this.setStringMetadataList([]);
};


/**
 * repeated NumericMetadata numeric_metadata = 5;
 * @return {!Array<!proto.loupe.common.insight.NumericMetadata>}
 */
proto.loupe.common.insight.Entity.prototype.getNumericMetadataList = function() {
  return /** @type{!Array<!proto.loupe.common.insight.NumericMetadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_insight_numeric_metadata_pb.NumericMetadata, 5));
};


/**
 * @param {!Array<!proto.loupe.common.insight.NumericMetadata>} value
 * @return {!proto.loupe.common.insight.Entity} returns this
*/
proto.loupe.common.insight.Entity.prototype.setNumericMetadataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.loupe.common.insight.NumericMetadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.insight.NumericMetadata}
 */
proto.loupe.common.insight.Entity.prototype.addNumericMetadata = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.loupe.common.insight.NumericMetadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.insight.Entity} returns this
 */
proto.loupe.common.insight.Entity.prototype.clearNumericMetadataList = function() {
  return this.setNumericMetadataList([]);
};


/**
 * repeated DateMetadata date_metadata = 6;
 * @return {!Array<!proto.loupe.common.insight.DateMetadata>}
 */
proto.loupe.common.insight.Entity.prototype.getDateMetadataList = function() {
  return /** @type{!Array<!proto.loupe.common.insight.DateMetadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_insight_date_metadata_pb.DateMetadata, 6));
};


/**
 * @param {!Array<!proto.loupe.common.insight.DateMetadata>} value
 * @return {!proto.loupe.common.insight.Entity} returns this
*/
proto.loupe.common.insight.Entity.prototype.setDateMetadataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.loupe.common.insight.DateMetadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.insight.DateMetadata}
 */
proto.loupe.common.insight.Entity.prototype.addDateMetadata = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.loupe.common.insight.DateMetadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.insight.Entity} returns this
 */
proto.loupe.common.insight.Entity.prototype.clearDateMetadataList = function() {
  return this.setDateMetadataList([]);
};


/**
 * repeated BoolMetadata bool_metadata = 7;
 * @return {!Array<!proto.loupe.common.insight.BoolMetadata>}
 */
proto.loupe.common.insight.Entity.prototype.getBoolMetadataList = function() {
  return /** @type{!Array<!proto.loupe.common.insight.BoolMetadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_insight_bool_metadata_pb.BoolMetadata, 7));
};


/**
 * @param {!Array<!proto.loupe.common.insight.BoolMetadata>} value
 * @return {!proto.loupe.common.insight.Entity} returns this
*/
proto.loupe.common.insight.Entity.prototype.setBoolMetadataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.loupe.common.insight.BoolMetadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.insight.BoolMetadata}
 */
proto.loupe.common.insight.Entity.prototype.addBoolMetadata = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.loupe.common.insight.BoolMetadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.insight.Entity} returns this
 */
proto.loupe.common.insight.Entity.prototype.clearBoolMetadataList = function() {
  return this.setBoolMetadataList([]);
};


goog.object.extend(exports, proto.loupe.common.insight);
